import React, { createContext, useState } from "react";

const TitleBarContext = React.createContext<{
  titleBarText: string;
  updateTitleBar: (text: string) => void;
}>({ titleBarText: "", updateTitleBar: () => {} });

interface TitleBarContextProviderProps {}
const TitleBarContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [titleBarText, setTitleBar] = useState("");
  const updateTitleBar = (text: string) => {
    setTitleBar(text);
  };
  return (
    <TitleBarContext.Provider value={{ titleBarText, updateTitleBar }}>
      {children}
    </TitleBarContext.Provider>
  );
};

export { TitleBarContext, TitleBarContextProvider };
